import { useState } from "react";

interface IUsePaginationHook {
  currentPage: number;
  direction: boolean;
  goToPage: (page: number) => void;
  maxPage: number;
  next: () => void;
  prev: () => void;
  setDirection: React.Dispatch<React.SetStateAction<boolean>>;
  resetPage: () => void;
}

function useTablePagination(
  itemsPerPage: number,
  totalNoOfTransactions: number
): IUsePaginationHook {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [direction, setDirection] = useState<boolean>(false);

  const maxPage = Math.ceil((totalNoOfTransactions || 0) / itemsPerPage);

  function next(): void {
    setCurrentPage((currPage) => Math.min(currPage + 1, maxPage));
  }

  function prev(): void {
    setCurrentPage((currPage) => Math.max(currPage - 1, 1));
  }

  function goToPage(page: number): void {
    // maxPage is 0 until the first page of results has been counted, so
    // clamping only at the top would hand back page 0 — which the API rejects
    // and which turns into a negative offset downstream.
    setCurrentPage(() => Math.max(1, Math.min(page, maxPage)));
  }

  function resetPage(): void {
    setCurrentPage(1);
  }

  return {
    currentPage,
    direction,
    goToPage,
    maxPage,
    next,
    prev,
    setDirection,
    resetPage,
  };
}

export default useTablePagination;
